(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', './ModalContext'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('./ModalContext'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.ModalContext);
    global.ModalProvider = mod.exports;
  }
})(this, function (exports, _extends2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _ModalContext) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var React = _interopRequireWildcard(_react);

  var _ModalContext2 = _interopRequireDefault(_ModalContext);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ModalProvider = function (_React$Component) {
    (0, _inherits3.default)(ModalProvider, _React$Component);

    function ModalProvider() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, ModalProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        modalComponent: null,
        props: {}
      }, _this.showModal = function (modalComponent) {
        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this.setState({
          modalComponent: modalComponent,
          props: props
        });
      }, _this.closeModal = function () {
        return _this.setState({
          modalComponent: null,
          props: {}
        });
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ModalProvider.prototype.render = function render() {
      var newValue = (0, _extends3.default)({}, this.state, {
        showModal: this.showModal,
        closeModal: this.closeModal
      });
      return React.createElement(
        _ModalContext2.default.Provider,
        { value: newValue },
        this.props.children
      );
    };

    return ModalProvider;
  }(React.Component);

  exports.default = ModalProvider;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/ModalManager/ModalProvider.js
// module id = 1188
// module chunks = 0